<section class="section-pd">
    <div class="trinka_container container">
        <div class="row match-box justify-content-center">
            <div class="col-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>{{ title }}</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="ins-bg">
            <span class="shape">
                <svg width="1301" height="759" viewBox="0 0 1301 759" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_f_104_913)">
                    <ellipse cx="650.061" cy="379.061" rx="488.5" ry="217.5" fill="#AD7FF9"/>
                    </g>
                    <defs>
                    <filter id="filter0_f_104_913" x="-9.15527e-05" y="-9.15527e-05" width="1300.12" height="758.121" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                    <feGaussianBlur stdDeviation="80.7803" result="effect1_foregroundBlur_104_913"/>
                    </filter>
                    </defs>
                </svg> 
            </span>
            <div class="row match-box">
                <div class="col-sm-6 dflex">
                    <div class="integritySolution c-card">
                        <h4 class="text-center">Kompatibel mit</h4>
                        <div class="text-center">
                            <img src="assets/images/enterprise/academic-institution/grammar-checker-works-with.webp"  alt="integrity-solution" class="img-fluid" />
                        </div>
                        <small>und mehr...</small>
                    </div>
                </div>
                <div class="col-sm-6 dflex">
                    <div class="integritySolution c-card">
                        <h4 class="text-center">LMS-Integrationen</h4>
                        <div class="text-center mt-4">
                            <img src="assets/images/enterprise/academic-institution/lms-integration.webp" alt="LMS Integrations" class="img-fluid" />
                        </div>
                        <small>und mehr...</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>